import angular from 'angular';

export class PreventionComponent {}

export default angular.module('directives.prevention', [])
  .component('prevention', {
    template: require('./prevention.template.html'),
    controller: PreventionComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/service/prevention.component.js